import { LocaleEnum } from '../../../../schema/locale';
import * as enUs from './en-us';
import * as enEu from './en-eu';
import * as enUk from './en-uk';
import * as deEu from './de-eu';
import * as nlEu from './nl-eu';
import * as seEu from './se-eu';
import * as frEu from './fr-eu';
import * as esEu from './es-eu';

import { AgResourceLanguage } from './types';

export const resources: Record<LocaleEnum, AgResourceLanguage> = {
  [LocaleEnum.enUS]: enUs,
  [LocaleEnum.apacUS]: enUs,
  [LocaleEnum.enAU]: enUs,
  [LocaleEnum.enNZ]: enUs,
  [LocaleEnum.enUK]: enUk,
  [LocaleEnum.enEU]: enEu,
  [LocaleEnum.enJP]: enUs,
  [LocaleEnum.jaJP]: enUs,
  [LocaleEnum.deEU]: deEu,
  [LocaleEnum.seEU]: seEu,
  [LocaleEnum.nlEU]: nlEu,
  [LocaleEnum.enDev]: enUs,
  [LocaleEnum.enQa]: enUs,
  [LocaleEnum.deQa]: deEu,
  [LocaleEnum.enAud]: enUs,
  [LocaleEnum.enNzd]: enUs,
  [LocaleEnum.enEud]: enEu,
  [LocaleEnum.deEud]: deEu,
  [LocaleEnum.enUkd]: enUk,
  [LocaleEnum.frEU]: frEu,
  [LocaleEnum.esEU]: esEu
};
